import Address from '../user/address';

export default class CheckoutAdditionalData {
  complement?: string;
  numberAddress?: string;

  constructor(address: Address) {
    this.complement = address.complement;
    this.numberAddress = address.numberAddress;
  }
}
